import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp, viewport } from "@/lib/motion";
import { ECOSYSTEM } from "@/data/smartContainer";
import SectionHeader from "./SectionHeader";

export default function ConnectedWorkspace() {
  return (
    <section id="workspace" className="py-24 sm:py-32 bg-slate-50/60 border-y border-slate-200/70" data-testid="connected-workspace-section">
      <div className="dm-container">
        <SectionHeader
          eyebrow="Connected Workspace"
          title="One seamless operation across the DeMaxtore ecosystem."
          description="Your SmartContainer™ flows automatically into every downstream stage — no re-entry, no handoffs, no lost context."
        />
        <motion.div initial="hidden" whileInView="visible" viewport={viewport} transition={{ staggerChildren: 0.1 }}
          className="mt-16 flex flex-col lg:flex-row items-stretch lg:items-center justify-center gap-3 lg:gap-1">
          {ECOSYSTEM.map((node, i) => (
            <React.Fragment key={node.label}>
              <motion.div variants={fadeUp}
                className="dm-card dm-card-hover flex lg:flex-col items-center gap-3 lg:gap-2 px-5 py-4 lg:py-6 lg:w-40 lg:text-center"
                data-testid={`ecosystem-node-${i}`}>
                <span className="grid place-items-center h-10 w-10 rounded-xl bg-blue-50 border border-blue-100 shrink-0">
                  <node.icon className="h-5 w-5 text-blue-600" strokeWidth={1.75} />
                </span>
                <span className="text-sm font-semibold text-slate-900 leading-tight">{node.label}</span>
              </motion.div>
              {i < ECOSYSTEM.length - 1 && (
                <motion.div variants={fadeUp} className="grid place-items-center py-1 lg:py-0">
                  <ArrowRight className="h-5 w-5 text-slate-300 rotate-90 lg:rotate-0" strokeWidth={2} />
                </motion.div>
              )}
            </React.Fragment>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
